import { render, staticRenderFns } from "./Liquidaciones.vue?vue&type=template&id=899f688c&scoped=true"
import script from "./Liquidaciones.vue?vue&type=script&lang=js"
export * from "./Liquidaciones.vue?vue&type=script&lang=js"
import style0 from "./Liquidaciones.vue?vue&type=style&index=0&id=899f688c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f688c",
  null
  
)

export default component.exports